import LuckyDrawBindingDialog from './luckyDrawBindingDialog.container'

export default LuckyDrawBindingDialog